 const checkForTermination = (question, value) => {
  if (!question.terminateLogic || !question.terminateLogic.relatedAnswer) {
    return false;
  }

  // For radio group (single choice)
  if (question.type === 'radiogroup') {
    return question.terminateLogic.relatedAnswer[value];
  }

  // For checkbox (multi choice)
  if (question.type === 'checkbox') {
    // Check if any selected value has termination enabled
    return value.some(val => question.terminateLogic.relatedAnswer[val]);
  }

  return false;
};

export { checkForTermination };